<template>
  <a-card v-if="pageLoading">
    <a-spin
      tip="Your document is being processed, do not leave this page!"
      :spinning="pageLoading"
    />
  </a-card>
  <a-form :form="form" v-else>
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
        <a-form-item label="No PP">
          <a-select
            :disabled="active || mode === 'Edit' || reportDataList.length > 0"
            showSearch
            placeholder="Select No. PP"
            @change="handleNo"
            :filterOption="handleFilterNoPP"
            v-decorator="[
              'id_pp',
              {
                rules: [{ required: true }],
                initialValue: initialData.no_pp,
              },
            ]"
          >
            <a-select-option v-for="item in listNoPp" :key="item.id_pp">
              {{
              item.no_pp
              }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Reporting Date">
          <a-date-picker
            placeholder="Select Date"
            disabled
            :format="getDefaultDateFormat"
            v-decorator="[
              'tanggal_pelaporan',
              {
                rules: [{ required: true }],
                initialValue: initialData.tanggal_pelaporan,
              },
            ]"
          />
        </a-form-item>
        <div style="display:none">
          <a-form-item label="Vice President Finance Approval">
            <a-input
              disabled
              v-decorator="[
              'bod',
              { rules: [{ required: true }], initialValue: initialData.bod },
            ]"
            ></a-input>
          </a-form-item>
        </div>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  name: "informasiKlaimPp",
  props: {
    data: {},
    others: {},
    mode: String,
    active: Boolean,
    reportDataList: {},
  },
  data() {
    return {
      listNoPp: [],
      pageLoading: true,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    if (this.mode === "Create" && !this.active) {
      this.listNoPp = [];
      this.fetchKlaimPp();
    } else {
      this.pageLoading = false;
    }
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    initialData() {
      if (this.data === undefined || this.data.length <= 0) {
        return {
          no_pp: [],
          tanggal_pelaporan: moment(),
          atasan: "",
          pimpro: "",
          actor_label: "Actor",
          actor: "",
          peruntukan: "",
          bod: "",
          catatan: "",
        };
      } else {
        let peruntukan = "";
        if (this.mode === "Create") {
          peruntukan = this.data.peruntukan;
        } else {
          peruntukan = this.others.peruntukan;
        }
        return {
          no_pp: this.data.no_pp,
          tanggal_pelaporan: moment(this.data.tanggal_pelaporan),
          pimpro: this.data.pimpro,
          id_pp: this.data.id_pp,
          bod: this.data.bod,
          // bod_name : this.data.bod_name,
          peruntukan: peruntukan,
          catatan: this.data.catatan,
        };
      }
    },
  },
  watch: {
    reportDataList() {
      if (this.reportDataList.length == 0) {
        this.fetchKlaimPp();
      }
    },
  },
  methods: {
    moment,
    async fetchKlaimPp() {
      await axios({
        method: "get",
        url: this.$serviceUrl + "klaim_biaya_pp/no_pp",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.listNoPp = response.data.no_pp;
          this.pageLoading = false;
        })
        .catch((err) => {
          if (this.mode === "Create") {
            let response = Object.assign({}, err.response.data);
            if (response.message === "Tidak Memiliki No PP") {
              this.displayMessage("no-active-pp");
            } else {
              this.displayMessage("404");
            }
            this.$router.go(-1);
          } else {
            this.pageLoading = false;
            this.loading = false;
          }
        });
    },
    handleFilterNoPP(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    handleNo(e) {
      let data = {};
      data = this.listNoPp.filter(
        (obj) => obj.id_pp.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      this.initialData.pimpro = data[0].pimpro;
      this.initialData.peruntukan = data[0].peruntukan;
      this.initialData.bod = data[0].bod + " - " + data[0].nama_bod;
      this.initialData.id_pp = data[0].id_pp;
      this.initialData.no_pp = data[0].no_pp;
      this.form.setFieldsValue({
        // actor: this.initialData.actor,
        bod: this.initialData.bod,
      });
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        const informasi = {
          tanggal_pelaporan: values.tanggal_pelaporan,
          no_pp: this.initialData.no_pp,
          // id_pp: this.mode === 'Edit'? this.data.id_pp:values.id_pp,
          id_pp: this.initialData.id_pp,
          pimpro: values.pimpro || "",
          peruntukan: this.initialData.peruntukan || "",
          bod: this.initialData.bod,
          catatan: this.initialData.catatan,
          // bod_name: this.initialData.bod_name,
        };
        Event.$emit("childInfo", informasi);
      });
    },
    beforeRouteEnter(to, from, next) {
      this.fetchKlaimPp((err, post) => {
        next();
      });
    },
    clearForm() {
      this.form.resetFields();
    },
  },
};
</script>

<style></style>
